import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=0384afd6&"
import script from "./Task.vue?vue&type=script&lang=ts&"
export * from "./Task.vue?vue&type=script&lang=ts&"
import style0 from "./Task.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports